import Link from "./Links";

export default Link;
